import React, { useState } from "react";
import { Button, FormControl, ListItemIcon, Menu, MenuItem, Select, Stack } from "@mui/material";
import { Add, CalendarMonth, DescriptionOutlined, ExpandMore, ShowChart } from "@mui/icons-material";

import { ramoFilterOptions, yearFilterOptions } from "../constants";

function DashboardFilters({ yearFilter, onYearFilterChange, ramiFilter, onRamiFilterChange, theme }) {
  const [quickActionAnchor, setQuickActionAnchor] = useState(null);
  const isQuickActionOpen = Boolean(quickActionAnchor);

  const handleOpenQuickAction = (event) => {
    setQuickActionAnchor(event.currentTarget);
  };

  const handleCloseQuickAction = () => {
    setQuickActionAnchor(null);
  };

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ sm: "center" }} justifyContent="flex-end" mb={3}>
      <FormControl size="small" sx={{ minWidth: 185 }}>
        <Select value={yearFilter} onChange={(e) => onYearFilterChange(e.target.value)}>
          {yearFilterOptions.map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 185 }}>
        <Select value={ramiFilter} onChange={(e) => onRamiFilterChange(e.target.value)}>
          {ramoFilterOptions.map((option) => (
            <MenuItem key={option} value={option}>{option}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button
        variant="contained"
        startIcon={<Add />}
        endIcon={<ExpandMore />}
        onClick={handleOpenQuickAction}
        sx={{ borderRadius: 3, px: 2.25, fontWeight: 700 }}
      >
        Azione rapida
      </Button>

      <Menu
        anchorEl={quickActionAnchor}
        open={isQuickActionOpen}
        onClose={handleCloseQuickAction}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 240,
            borderRadius: 3,
            border: `1px solid ${theme.palette.divider}`,
            boxShadow: "none",
            p: 1,
          },
        }}
      >
        <MenuItem onClick={handleCloseQuickAction}>
          <ListItemIcon>
            <Add fontSize="small" />
          </ListItemIcon>
          Nuovo preventivo
        </MenuItem>
        <MenuItem onClick={handleCloseQuickAction}>
          <ListItemIcon>
            <DescriptionOutlined fontSize="small" />
          </ListItemIcon>
          Emetti polizza
        </MenuItem>
        <MenuItem onClick={handleCloseQuickAction}>
          <ListItemIcon>
            <CalendarMonth fontSize="small" />
          </ListItemIcon>
          Vedi scadenze
        </MenuItem>
        <MenuItem onClick={handleCloseQuickAction}>
          <ListItemIcon>
            <ShowChart fontSize="small" />
          </ListItemIcon>
          Report
        </MenuItem>
      </Menu>
    </Stack>
  );
}

export default DashboardFilters;
